import { useQuery } from '@apollo/client';
import { isNil } from 'lodash';
import { Queries } from '@shared/api';
import { API } from '@shared/types/api';

export function useWorkflowTemplate(id?: string | null): {
  workflowTemplate?: API.WorkflowTemplate;
  loading: boolean;
  error?: Error;
} {
  const { data, loading, error } = useQuery<
    API.GetWorkflowTemplateQuery,
    API.GetWorkflowTemplateQueryVariables
  >(Queries.workflow.getWorkflowTemplate, {
    variables: { id: id ?? '' },
    skip: isNil(id),
  });
  const workflowTemplate = (data?.getWorkflowTemplate ?? undefined) as
    | API.WorkflowTemplate
    | undefined;
  return { workflowTemplate, loading, error };
}
